import React, { useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { inject, observer } from "mobx-react";
import { Framework } from '@flint/framework';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';
import htmlReactParser from 'html-react-parser';


const useStyles = makeStyles((theme) => ({
    paper: {
        width: "100%",
        padding: theme.spacing(2),
    },
    bigDialog:{
        maxWidth:"1000px",
        maxHeight:"unset",
    },
    title: {
        flex: '1 1 100%',
        fontFamily: "Merriweather",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "28px",
        lineHeight: "90px",
        color: "#222747",
    },
    form: {
        display: "flex",
        flexDirection: "column",
    },
    formLabel: {
        flex: "1",
        fontSize: "17px",
        fontFamily: "Nunito Sans",
        fontStyle: "normal",
        lineHeight: "30px",
        color: "#000000",
    },
    button: {
        color: "#FFF",
        padding: "15px",
        fontSize: "18px",
        fontFamily: "Nunito Sans",
        fontStyle: "normal",
        fontWeight: "bold",
        lineHeight: "20px",
        background: "#222747",
        borderRadius: "3px",
        textTransform: "unset",
        transition: "background 0.25s",
        border: "2px solid #222747",
        maxHeight:"55px",
        "&:hover": {
            background: "none",
            color: "#222747",
        }
    },
    mtop: {
        marginTop: theme.spacing(2),
    },
    mleft: {
        marginLeft: theme.spacing(2),
    },
}));

const CSVUploadForm=({ CSVUploadStore, CSVUploadStoreStatus})=>{
    const classes = useStyles();

    const [formError,setFormError] =useState({error:false,helperText:"Please select a file..."});

    const [btnText, setBtnText] = useState('Submit');
    const [btnStyle, setBtnStyle] = useState({});

    const [open, setOpen] = React.useState(false);

    const [mappingExcel,setMappingExcel]=React.useState({name:""});
    const excelInputFileRef=React.useRef();

    const handleClose = () => {
        setOpen(false);
        setBtnText("Submit");
        setBtnStyle({});
        setMappingExcel({name:""});
    };

    const handleGoToHome = () => {
        Framework.redirect(`/`);
    }

    const submitCSV = (e) => {
        e.preventDefault();
        if(mappingExcel.name===""){
            setFormError({...formError,error:true});
        }
        else {
            setBtnStyle({
                "pointerEvents": "none",
                "opacity": "0.5",
            })
            setBtnText('Uploading...');
            setFormError({...formError,error:false});
            CSVUploadStore.fetch(mappingExcel);
            setOpen(true);
            CSVUploadStore.reset();
        }
        excelInputFileRef.current.value="";
    }

    const fileSelected = (e) => {
        setMappingExcel(e.target.files[0]);
    }


    return(
        <>
        {CSVUploadStoreStatus.isPending ? <LinearProgress color="secondary" /> : <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="bigDialog"
            >
                <DialogTitle id="alert-dialog-title">Upload Mapping</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {htmlReactParser(CSVUploadStore.res)}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" autoFocus>
                        Upload More
                    </Button>
                    <Button onClick={handleGoToHome} color="primary">
                        Go To Home
                    </Button>
                </DialogActions>
            </Dialog>}

        <Box display="flex" justifyContent="center" p={4}>
            <Grid item xs={12} sm={10} md={8} lg={6}>
                <Paper className={classes.paper}>
                    <form className={classes.form}>
                        <Typography className={classes.title} variant="h1" id="tableTitle" component="div">
                            Upload Mapping
                        </Typography>
                        <Grid container justify="space-between" spacing={1}>
                            <TextField className={classes.formLabel} disabled id="outlined-basic" placeholder="Upload excel file" variant="outlined" value={mappingExcel.name} {...formError.error?formError:null} />
                            <Button className={`${classes.button} ${classes.mleft}`} variant="contained" component="label">
                                Select File<input type="file" hidden id="csvfile" name="file" ref={excelInputFileRef} onChange={fileSelected} accept=".xlsx"/>
                            </Button>
                        </Grid>
                        <Grid container justify="center" p={1} className={classes.mtop}>
                            <Button className={classes.button} onClick={submitCSV} style={btnStyle} variant="contained" component="label">{btnText}</Button>
                        </Grid>
                    </form>
                </Paper>
            </Grid>
        </Box >
        </>
    )
}

export default inject('CSVUploadStore', 'CSVUploadStoreStatus')(observer(CSVUploadForm));